import { Search } from "@mui/icons-material"
import { Autocomplete, InputAdornment, Stack, TextField, Typography } from "@mui/material"
import React from "react"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { Box } from "@mui/system"
import { Collaborator } from "../../../core/dto/user/collaborator"
import { CollaboratorTypeEnum } from "../../../core/enum/user/collaboratorTypeEnum"

interface IProps {
  fieldName: string
  label: string
  value: Collaborator | null
  options: Collaborator[] | undefined
  disablePortal?: boolean
  errors: Record<string, string | undefined>

  onChange(event: any, newValue: Collaborator | null): void

  getOptionLabel(option: Collaborator): string
}

export function CollaboratorAutocompleteInput({
  fieldName,
  label,
  value,
  options,
  onChange,
  getOptionLabel,
  disablePortal = true,
  errors,
}: Readonly<IProps>): React.JSX.Element {
  const isError: boolean = fieldName ? !!errors?.[fieldName] : false

  return (
    <Autocomplete
      fullWidth
      disablePortal={disablePortal}
      id="searchBar"
      value={value}
      options={options ?? []}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, valueToCompare) => option === valueToCompare}
      renderOption={(liProps, collaborator) => (
        <li {...liProps} key={collaborator.cognitoUserId}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {/* Texte principal */}
            <Typography>{getOptionLabel(collaborator)}</Typography>

            {/* Icône conditionnelle */}
            {collaborator.type === CollaboratorTypeEnum.WAITING_CREATION && (
              <Box sx={{ color: "warning.main", display: "flex", justifyContent: "center", alignItems: "center", gap: 0.5 }}>
                <AccessTimeIcon sx={{ fontSize: 18, color: "warning.main" }} />
                en attente
              </Box>
            )}
          </Stack>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={label}
          fullWidth
          error={isError}
          helperText={fieldName && errors?.[fieldName] ? errors?.[fieldName] : undefined}
          sx={{
            borderRadius: "4px",
            boxSizing: "border-box",
            "& .MuiInputBase-root": {
              background: "#0000000F 0% 0% no-repeat padding-box;",
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}
